var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestionTruefalse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 8V6H14V18H16V13H22V11H16V8H22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6V8H6V18H8V8H12V6H2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionTruefalse);
export default __webpack_public_path__ + "static/media/icon-question-truefalse.e7a96c7064c028c202c2dc20803ffcba.svg";
export { ForwardRef as ReactComponent };